import React from 'react'
import {
  Row,
  Typography,
  Form,
  Select,
  Input,
  Col,
  Button,
  Checkbox,
} from "antd";


const { Text, Title } = Typography

const CampaignForm = (props) => {
  return (
    <Form
      layout="vertical"
      onFinish={props.onFinish}
      form={props.form}
      initialValues={props.initialValues}
      style={{ margin: 30 }}
    >
      <Row>

        <Form.Item
          label={<Text strong>Campaign Name</Text>}
          name={"campaignName"}
          rules={[{ required: true, message: "Required Field" }]}
        >
          <Input
            placeholder="xxxxxxxxx"
            style={{ width: "30vh" }}

          />
        </Form.Item>
      </Row>

      <Row>
        <Form.Item
          name={"isNotification"}>
          <Checkbox  ><Text strong>Is Notification</Text></Checkbox>
        </Form.Item>
      </Row>

      <Row>
        <Form.Item
          label={<Text strong>SMS Provider</Text>}
          name={"smsProvider"}
          rules={[{ required: true, message: "Required Field" }]}
        >
          <Select style={{ width: "30vh" }} showSearch />

        </Form.Item>
      </Row>

      <Row>
        <Form.Item
          label={<Text strong>Trigger Type</Text>}
          name={"triggerType"}
          rules={[{ required: true, message: "Required Field" }]}
        >
          <Select style={{ width: "30vh" }} showSearch />

        </Form.Item>
      </Row>

      <Row>
        <Form.Item
          label={<Text strong>Business Rule</Text>}
          name={"businessRule"}
          rules={[{ required: true, message: "Required Field" }]}
        >
          <Select style={{ width: "30vh" }} showSearch />
        </Form.Item>
      </Row>

      <Row>
        <Title level={3}>Business Rule Parameters</Title>
      </Row>
    </Form>

  )
}

export default CampaignForm